export const flagKey = {
  posOrderEdit: 'pos-order-edit',
  payengineTerminalEdit: 'payengine-terminal-order-edit',
  orderSubtype: 'order-subtype',
}
